import React from 'react';
import '../styles/style.css'

export class Makerslist extends React.Component {
    makers (marray) {
        let makersname = [];
        for (let i=0; i<marray.length; i++) {
            makersname.push(marray[i].name);
        }
        return makersname;
    };
    render () {
        let makersarray = this.props.makerslist;
        let makersnamearray = this.makers(makersarray);
        let outputexp;
        // Check if any maker is redacted or missing
        const hasRedacted = makersnamearray.some(name =>
            !name ||
            name === '[REDACTED]' ||
            name.trim() === '' ||
            name === null ||
            name === undefined
        );
        if (hasRedacted || makersnamearray.length === 0) {
            const makerCount = makersnamearray.length || 1; // At least 1 if we have redacted data
            return (
                <div>
                    <span className="badge badge-success">{makerCount} Maker{makerCount !== 1 ? 's' : ''}</span>
                    <br />
                    <small className="text-muted" data-toggle="tooltip" data-placement="top" title="Private data hidden for privacy reasons">(Private)</small>
                </div>
            );
        }
        if (makersnamearray.length === 0) {
            outputexp = <div></div>
        } else if (makersnamearray.length === 1) {
            outputexp = <p className="text-muted">{makersnamearray[0]}</p>
        } else if (makersnamearray.length === 2) {
            outputexp = (
                <div>
                    <p className="text-muted">{makersnamearray[0]}</p>
                    <p className="text-muted">{makersnamearray[1]}</p>
                </div>
            )
        } else if (makersnamearray.length === 3) {
            outputexp = (
                <div>
                    <p className="text-muted">{makersnamearray[0]}</p>
                    <p className="text-muted">{makersnamearray[1]}</p>
                    <p className="text-muted">{makersnamearray[2]}</p>
                </div>
            )
        } else {
            outputexp = (
                <div>
                    <p className="text-muted">{makersnamearray[0]}</p>
                    <p className="text-muted">{makersnamearray[1]}</p>
                    <p className="text-muted">{makersnamearray[2]}</p>
                    <h6>+{makersnamearray.length - 3} more makers</h6>
                </div>  
            )
        }
        return outputexp;
    }
};